import Vue from 'vue'
import { mapState } from 'vuex'

import Button from '@/components/button/basic-button.vue'
import { validateEmail } from '@/lib/helpers'

export default Vue.extend({
  name: 'Login',
  components: {
    'v-button': Button
  },

  data() {
    return {
      email: '',
      error: false,
      required(propertyType: any) {
        return (v: string) =>
            (v && v.length > 0) || `${propertyType}は入力必須項目です`
      },
      validEmail() {
        let re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        return (v: string) =>
            (v && re.test(v)) || `正しいメールアドレスを入力してください`
      }
    }
  },

  created() {
    this.$store.dispatch('loading', false)
    this.$store.dispatch('clearMessage')
  },

  computed: {
    ...mapState(['loading', 'message'])
  },

  methods: {
    sendEmail() {
      this.$store.dispatch('clearMessage')
      this.error = false
      if (!this.email || !validateEmail(this.email)) {
        this.error = true
        return
      }
      this.$store.dispatch('loading')
      this.$store.dispatch('resetPassword', { email: this.email })
        .then(() => {
          this.$store.dispatch('loading', false)
          this.$router.push({ path: '/reset_password/temporary' })
        })
        .catch(err => {
          // Handle error
          return (err)
        })
    },
    back() {
      this.$router.push({ path: '/login' })
    }
  }
})
